var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-field",class:{
    'text-field--rounded': _vm.rounded,
    'text-field--shadow': _vm.shadow,
    'text-field--search': _vm.theme == 'search',
  }},[(_vm.iconLeft !== '')?_c('icons',{staticClass:"text-field__ic-left",attrs:{"icon":_vm.iconLeft,"color":"#00A4B3"}}):_vm._e(),_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder},on:{"click":function($event){return _vm.$emit('click')},"input":function($event){return _vm.$emit('input', $event.target.value)}}}),(_vm.iconRight !== '')?_c('icons',{staticClass:"text-field__ic-right",attrs:{"icon":_vm.iconRight,"color":"#00A4B3"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }